module.exports = __webpack_public_path__ + "img/CatalystStaticpageimage.1ffd7b67.webp";